export default function apiURL(url) {
  if (url && url === "authentication") {
    // return "http://localhost:5001/authentication/";
    
    if (window.location.hostname === "qaapiv4.sikkasoft.com" || window.location.hostname ==="localhost") {
      return "https://qaapiv4.sikkasoft.com/portal-apis/authentication/";
      // return "https://v4portalapis.sikkasoft.com/portal-apis/authentication/";
    } else {
      // return "https://qaapiv4.sikkasoft.com/portal-apis/authentication/";
      return "https://v4portalapis.sikkasoft.com/portal-apis/authentication/";
    }
  } else {
    // return "http://localhost:5001/apiportalapi/";
    if (window.location.hostname === "qaapiv4.sikkasoft.com" || window.location.hostname ==="localhost") {
      return "https://qaapiv4.sikkasoft.com/portal-apis/apiportalapi/";
      // return "https://v4portalapis.sikkasoft.com/portal-apis/apiportalapi/";
    } else {
      // return "https://qaapiv4.sikkasoft.com/portal-apis/apiportalapi/";
      return "https://v4portalapis.sikkasoft.com/portal-apis/apiportalapi/";   
    }
  }
}
// for testing purpose
// export default function apiURL(url) {
//   if (url && url === "authentication") {
//     // return "http://localhost:5001/authentication/";
//     if (window.location.hostname === "qaapiv4.sikkasoft.com" || window.location.hostname ==="localhost") {
//       //return "https://qaapiv4.sikkasoft.com/portal-apis/authentication/";
//       // return "https://v4portalapis.sikkasoft.com/portal-apis/authentication/";
//       return "https://localhost:44361/authentication/"
//       // return "https://qaapiv4.sikkasoft.com/portal-apis/authentication/";
//       return "https://v4portalapis.sikkasoft.com/portal-apis/authentication/";
//     }
//   } else {
//     // return "http://localhost:5001/apiportalapi/";
//     if (window.location.hostname === "qaapiv4.sikkasoft.com" || window.location.hostname ==="localhost") {
//       //return "https://qaapiv4.sikkasoft.com/portal-apis/apiportalapi/";
//       // return "https://v4portalapis.sikkasoft.com/portal-apis/apiportalapi/";
//        return "https://localhost:44361/apiportalapi/";
//     } else {
//       // return "https://qaapiv4.sikkasoft.com/portal-apis/apiportalapi/";
//       // return "https://v4portalapis.sikkasoft.com/portal-apis/apiportalapi/";   
//     }
//     // https://localhost:44361/apiportalapi/table_configration
//   }
// }